import { createContext, useContext, useState, useCallback, useRef } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

const DemoGateContext = createContext({ gate: (fn) => fn && fn() });

export const useDemoGate = () => useContext(DemoGateContext);

export function DemoGateProvider({ children }) {
  const [open, setOpen] = useState(false);
  const actionRef = useRef(null);

  const gate = useCallback((action) => {
    actionRef.current = action;
    setOpen(true);
  }, []);

  const proceed = () => {
    setOpen(false);
    const action = actionRef.current;
    actionRef.current = null;
    if (typeof action === "function") action();
  };

  const cancel = () => {
    actionRef.current = null;
    setOpen(false);
  };

  return (
    <DemoGateContext.Provider value={{ gate }}>
      {children}
      <Dialog open={open} onOpenChange={(v) => (v ? setOpen(true) : cancel())}>
        <DialogContent className="border border-border bg-background sm:max-w-md" data-testid="demo-notice-modal">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl" data-testid="demo-notice-title">Demo Site Notice</DialogTitle>
            <DialogDescription className="pt-2 text-sm leading-relaxed text-muted-foreground">
              This is a demonstration website created for portfolio purposes only. No real salon appointments will be booked, and no services will be dispatched or fulfilled.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="mt-4 flex-col gap-3 sm:flex-row sm:justify-end">
            <button
              data-testid="demo-notice-cancel"
              onClick={cancel}
              className="border border-foreground/40 px-6 py-3 font-mono text-xs uppercase tracking-[0.16em] text-foreground transition-colors hover:border-foreground"
            >
              Cancel
            </button>
            <button
              data-testid="demo-notice-proceed"
              onClick={proceed}
              className="bg-primary px-6 py-3 font-mono text-xs uppercase tracking-[0.16em] text-primary-foreground transition-transform duration-300 hover:-translate-y-0.5"
            >
              Proceed to Demo
            </button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </DemoGateContext.Provider>
  );
}
